import { setupMarkdownToolPage } from './shared/index.js';
import { applyImageMode, convertOfficeFile, OFFICE_MAX_INPUT_BYTES, requireUploadConsent } from './formats/docx/office-client.js';

function isPptx(file) {
  return Boolean(file && (/\.pptx$/i.test(file.name) || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'));
}

export function initPptxPage(root = document) {
  const notes = root.querySelector('#pptx-notes');
  const imageMode = root.querySelector('#pptx-images');
  const uploadConsent = root.querySelector('#upload-consent');
  let sourceFile = null;
  const page = setupMarkdownToolPage({
    root,
    defaultFileName: 'pptx-document',
    onFiles: (files) => {
      const file = files?.[0];
      if (!file) return;
      try { requireUploadConsent(uploadConsent); } catch (error) { sourceFile = null; page.setReady(false); page.setStatus(error.message, 'error'); return; }
      if (files.length > 1) { page.setStatus('Choose one PPTX file at a time.', 'error'); return; }
      if (!isPptx(file)) { page.setStatus('Choose a PPTX file.', 'error'); return; }
      if (!file.size || file.size > OFFICE_MAX_INPUT_BYTES) {
        page.setStatus('The PPTX file must be between 1 B and 50.0 MB.', 'error');
        return;
      }
      sourceFile = file;
      page.setReady(true);
      page.setStatus(`${file.name} is ready. Choose note and image handling, then convert.`, 'success');
    },
  });
  uploadConsent?.addEventListener('change', () => {
    if (!uploadConsent.checked) page.setReady(false);
    else if (sourceFile) page.setReady(true);
  });
  page.elements.convertButton?.addEventListener('click', () => {
    if (!sourceFile) return;
    try { requireUploadConsent(uploadConsent); } catch (error) { page.setStatus(error.message, 'error'); return; }
    const selectedImageMode = imageMode?.value || 'links';
    const includeNotes = (notes?.value || 'include') === 'include';
    page.runConversion(async ({ signal, report }) => {
      const output = await convertOfficeFile(sourceFile, 'pptx', { includeNotes }, { signal, report, consent: Boolean(uploadConsent?.checked) });
      const converted = applyImageMode(output, selectedImageMode);
      report('Markdown is ready.', 1);
      return converted;
    }).catch(() => {});
  });
  page.elements.clearButton?.addEventListener('click', () => {
    sourceFile = null;
    page.setReady(false);
    page.result.clear();
    page.setStatus('Source cleared.');
  });
  page.setReady(false);
  return { page, get sourceFile() { return sourceFile; } };
}

if (typeof document !== 'undefined' && document.documentElement.dataset.markdownFormat === 'pptx') initPptxPage();
